import graphqlClient from "../../../apollo";

class MovimientoProvider {

    findMovimiento(id) {
        return graphqlClient.query({
            query: require('./gql/movimientoFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    fetchMovimientos(fechaDesde, fechaHasta) {
        return graphqlClient.query({
            query: require('./gql/movimientoFetch.graphql'),
            variables: { fechaDesde, fechaHasta },
            fetchPolicy: "network-only"
        })
    }

    fetchMovimientosFetchReporteStock() {
        return graphqlClient.query({
            query: require('./gql/movimientoFetchReporteStock.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateMovimientos(pageNumber, itemsPerPage, search = null, filters, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/movimientoPaginate.graphql'),
            variables: { pageNumber, itemsPerPage, search, filters, orderBy, orderDesc },
            fetchPolicy: "network-only"
        })
    }

    createMovimiento(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/movimientoCreate.graphql'),
            variables: form
        })
    }

    createDevolucion(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/devolucionCreate.graphql'),
            variables: form
        })
    }

    updateMovimiento(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/movimientoUpdate.graphql'),
            variables: form
        })
    }

    deleteMovimiento(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/movimientoDelete.graphql'),
            variables: { id }
        })
    }

}

export default new MovimientoProvider()


